function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Page, Button, TextField, PasswordField, Card, USPhoneNumberInput } from 'seagull';
import { nameValidation, requiredValidation, usPhoneNumberValidation } from 'validators';
import { useGlobalContext, useStore, useStoreActions } from "../../contexts";
import { Intent } from "../../infra/access-control";
import styles from "./Profile.module.scss";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { handleRequest } from "../../infra/utils";
const testPrefix = 'profile';
const title = 'Profile';
const nullIfEmpty = s => s || null;
export default function Profile() {
  var _userInfo$identityTyp;
  const globalContext = useGlobalContext();
  const userInfo = useStore(state => state.userInfo);
  const {
    setUserInfo,
    logBI,
    api
  } = useStoreActions();
  const {
    control,
    formState,
    handleSubmit,
    watch,
    trigger,
    clearErrors
  } = useForm({
    mode: 'onChange'
  });
  const userLoggedInViaLink = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.identityTypes) === null;
  const userHasPassword = userInfo === null || userInfo === void 0 || (_userInfo$identityTyp = userInfo.identityTypes) === null || _userInfo$identityTyp === void 0 ? void 0 : _userInfo$identityTyp.includes('password');
  const firstNameValidator = nameValidation('First name', {
    required: 'Please enter your first name'
  });
  const lastNameValidator = nameValidation('Last name', {
    required: 'Please enter your last name'
  });
  const currentPasswordValidator = requiredValidation(!!watch('newPassword') && 'Please enter your current password');
  const newPasswordValidator = {
    validate(password) {
      const hasPassword = !!password;
      hasPassword ? trigger('currentPassword') : clearErrors('currentPassword');
      const isValidPassword = hasPassword ? (password === null || password === void 0 ? void 0 : password.length) >= 10 : true;
      return isValidPassword || 'Use 10 or more characters';
    }
  };
  const confirmPasswordValidator = {
    validate(password) {
      return password === watch('newPassword') || 'Passwords must match';
    }
  };
  useEffect(() => {
    document.title = title;
  }, []);
  const onSubmit = async form => {
    logBI(10410);
    const updatedUserInfo = await handleRequest(api.auth.editUserDetails({
      name: {
        first: form.firstName,
        last: form.lastName
      },
      password: nullIfEmpty(form.newPassword),
      currentPassword: form.newPassword ? nullIfEmpty(form.currentPassword) : null,
      phone: nullIfEmpty(form.phone),
      clearPhoneNumber: !form.phone
    }));
    if (!updatedUserInfo.success) {
      globalContext.showErrorToast('An error occurred');
    } else {
      setUserInfo(_objectSpread(_objectSpread({}, userInfo), updatedUserInfo.data));
      globalContext.showSuccessToast('Changes saved');
    }
  };
  return /*#__PURE__*/React.createElement(Page, {
    header: title,
    skin: "secondary",
    "data-testid": "".concat(testPrefix, "-page"),
    actions: /*#__PURE__*/React.createElement(Button, {
      intent: Intent.UpdateProfile,
      type: "submit",
      form: testPrefix,
      loading: formState.isSubmitting,
      "data-testid": "".concat(testPrefix, "-btn-save-changes")
    }, "Save changes")
  }, /*#__PURE__*/React.createElement("form", {
    id: testPrefix,
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Section, {
    title: "Personal details"
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "firstName",
    defaultValue: userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName,
    rules: firstNameValidator,
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      label: "First name",
      "data-testid": "".concat(testPrefix, "-first-name")
    }))
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "lastName",
    defaultValue: userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName,
    rules: lastNameValidator,
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      label: "Last name",
      "data-testid": "".concat(testPrefix, "-last-name")
    }))
  }), /*#__PURE__*/React.createElement(TextField, {
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
    label: "Email address",
    type: "email",
    "data-testid": "".concat(testPrefix, "-email"),
    disabled: true
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "phone",
    defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone) || undefined,
    rules: usPhoneNumberValidation(),
    render: renderProps => /*#__PURE__*/React.createElement(USPhoneNumberInput, _extends({}, connectControllerToTextField(renderProps), {
      label: "Phone number",
      "data-testid": "".concat(testPrefix, "-phone")
    }))
  })), (userHasPassword || userLoggedInViaLink) && /*#__PURE__*/React.createElement(Section, {
    title: "Password"
  }, !userLoggedInViaLink && /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "currentPassword",
    rules: currentPasswordValidator,
    render: renderProps => /*#__PURE__*/React.createElement(PasswordField, _extends({}, connectControllerToTextField(renderProps), {
      label: "Current password",
      "data-testid": "".concat(testPrefix, "-current-password")
    }))
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "newPassword",
    rules: newPasswordValidator,
    render: renderProps => /*#__PURE__*/React.createElement(PasswordField, _extends({}, connectControllerToTextField(renderProps), {
      label: "New password",
      "data-testid": "".concat(testPrefix, "-new-password")
    }))
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "confirmPassword",
    rules: confirmPasswordValidator,
    render: renderProps => /*#__PURE__*/React.createElement(PasswordField, _extends({}, connectControllerToTextField(renderProps), {
      label: "Confirm password",
      "data-testid": "".concat(testPrefix, "-confirm-password")
    }))
  })))));
}
const Section = props => {
  return /*#__PURE__*/React.createElement(Card, {
    padding: "m",
    autoHeight: true,
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, props.children));
};